/**
 * design-tools/GlowLine.jsx
 * Decorative animated glow line — horizontal or vertical
 */
import { PALETTE } from './tokens';

export default function GlowLine({
  orientation = 'h', // 'h' | 'v'
  color = PALETTE.glow,
  opacity = 0.4,
  animated = false,
  style = {},
}) {
  const base = orientation === 'h'
    ? { width: '100%', height: '1px' }
    : { width: '1px', height: '100%' };

  return (
    <div
      style={{
        ...base,
        background: `linear-gradient(${orientation === 'h' ? '90deg' : '180deg'}, transparent, ${color}, transparent)`,
        opacity,
        flexShrink: 0,
        ...(animated ? { animation: 'glowPulse 3s ease-in-out infinite' } : {}),
        ...style,
      }}
    />
  );
}
